/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import drinks from '../assets/icons/drinks&juices.svg';
import freshproduct from '../assets/icons/freshfood.svg';
import Location from '../assets/icons/Location.svg';
import OpenHr from '../assets/icons/openhours.svg';
import Reserve from '../assets/icons/Reserve.svg';
import skilledchef from '../assets/icons/skilledchefs.svg';
import vegancuisine from '../assets/icons/vegancuisine.svg';
import burger from '../assets/images/burger.png';
import user from '../assets/images/dummyUser.jpg';

// const apiURL = 'http://3.215.205.6:3001';
const apiURL = 'http://api.swizzle.co.in';
// const apiURL = 'http://localhost:3001';
// const apiURL = 'https://5afb-103-41-25-175.ngrok-free.app';

const contactUs = {
  phone: '+1 852 346 000',
  email: 'info@foodzero.com',
  address: '1959 Sepulveda Blvd. Culver City, CA, 90230',
};
const storyData = [
  {
    title: 'Locate Us',
    icon: Location,
    tag: 'Riverside 25, San Francisco, California',
  },
  {
    title: 'Open Hours',
    icon: OpenHr,
    tag: 'Mon To Fri 9:00 AM - 9:00 PM',
  },
  {
    title: 'Reservation',
    icon: Reserve,
    tag: 'hirestaurantate@gmail.com',
  },
];

const menu = [
  {
    name: 'Cheese Burger',
    location: 'Burger Arena',
    price: '3.60',
    image: burger,
    id: '100',
  },
  {
    name: 'Toffe’s Cake',
    location: 'Top Sticks',
    price: '4.60',
    image: burger,
    id: '101',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '102',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '103',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '7',
    image: burger,
    id: '104',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '105',
  },
];

const aboutusList = [
  {
    id: '100',
    name: 'Fresh Product',
    icon: freshproduct,
    description: 'Professional consider everyone probls small niche friendly.',
  },
  {
    id: '101',
    name: 'Skilled Chefs',
    icon: skilledchef,
    description: 'Professional consider everyone probls small niche friendly.',
  },
  {
    id: '103',
    name: 'Drinks & Juices',
    icon: drinks,
    description: 'Professional consider everyone probls small niche friendly.',
  },
  {
    id: '104',
    name: 'Vegan Cuisine',
    icon: vegancuisine,
    description: 'Professional consider everyone probls small niche friendly.',
  },
];

const menuItems = [
  {
    name: 'Cheese Burger',
    location: 'Burger Arena',
    price: '3.60',
    image: burger,
    id: '100',
  },
  {
    name: 'Toffe’s Cake',
    location: 'Top Sticks',
    price: '4.60',
    image: burger,
    id: '101',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '102',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '103',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '104',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '105',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '106',
  },
  {
    name: 'Dancake',
    location: 'Cake World',
    price: '6',
    image: burger,
    id: '107',
  },
];

const reviews = [
  {
    name: 'Daniyal Sppra',
    location: 'New York',
    photo: user,
    review: "It is professional, considers everyone's time, can think about the  There are many variations of passages whole probls small niche, friendly.",
  },
  {
    name: 'Daniyal Sppra',
    location: 'New York',
    photo: user,
    review: "It is professional, considers everyone's time, can think about the  There are many variations of passages whole probls small niche, friendly.",
  },
  {
    name: 'Daniyal Sppra',
    location: 'New York',
    photo: user,
    review: "It is professional, considers everyone's time, can think about the  There are many variations of passages whole probls small niche, friendly.",
  },
  {
    name: 'Daniyal Sppra',
    location: 'New York',
    photo: user,
    review: "It is professional, considers everyone's time, can think about the  There are many variations of passages whole probls small niche, friendly.",
  },
];

const submenu = [
  {
    name: 'All',
    id: 'all',
  },
  {
    name: 'Starter',
    id: 'starter',
  },
  {
    name: 'Lunch',
    id: 'lunch',
  },
  {
    name: 'Dinner',
    id: 'dinner',
  },
  {
    name: 'Drinks',
    id: 'drinks',
  },
  {
    name: 'sweets',
    id: 'sweets',
  },
  {
    name: 'Fruits',
    id: 'fruits',
  },
];

const city = [
  {
    name: 'Chandigarh',
  },
  {
    name: 'Delhi',
  },
  {
    name: 'Pune',
  },
  {
    name: 'Mumbai',
  },
];

export {
  aboutusList,
  apiURL,
  city,
  contactUs,
  menu,
  menuItems,
  reviews,
  storyData,
  submenu
};

// ===
